// src/utils/formatters/dates.js
// Utilidades de fecha reutilizables (render + Excel).

export const DATE_FMT = 'dd/mm/yyyy';
export const DATETIME_FMT = 'dd/mm/yyyy hh:mm';


export function toDate(value) {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/**
 * Retorna fecha y hora formateada para usar en nombres de archivo (YYYY-MM-DD_HH-mm)
 */
export function getExportTimestamp(date = new Date()) {
  const d = toDate(date) || new Date();
  const yyyy = d.getFullYear();
  const MM = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const HH = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${yyyy}-${MM}-${dd}_${HH}-${mm}`;
}
